import React, { Component } from "react";
import { ButtonToolbar, Badge, Dropdown } from "react-bootstrap";
import { numberWithCommas } from "../../../helpers/dataHelpers";

import NoTableData from "../../../components/extensions/ErrorPageDefaults/NoTableData";

import { DropdownButton } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";

import {
  InventoryDetailsPdfToRenderOverallComponent,
  InventoryDetailsPdfToRenderAreaComponent,
  InventoryDetailsPdfToRenderBranchComponent,
} from "./InventoryDetailsPdfToRenderComponent";

import {
  InventoryDetailsExcelToRenderOverallComponent,
  InventoryDetailsExcelToRenderAreaComponent,
  InventoryDetailsExcelToRenderBranchComponent,
} from "./InventoryDetailsExcelToRenderComponent";
import TableLoader from "../../../components/extensions/TableLoader";

class InventoryDetailsViewer extends Component {
  state = {
    isLoading: false,
    areaList: [],
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    setTimeout(() => {
      this.setState({
        isLoading: false,
      });
    }, 1000);
  }

  renderPrintablePdfComponent = (list) => {
    let { searchBy } = this.props.data;

    switch (searchBy) {
      case "All":
        return InventoryDetailsPdfToRenderOverallComponent(list);

      case "Area":
        return InventoryDetailsPdfToRenderAreaComponent(list);

      case "Branch":
        return InventoryDetailsPdfToRenderBranchComponent(list);

      default:
        return "No Value";
    }
  };

  renderPrintableExcelComponent = (list) => {
    let { searchBy, filename } = this.props.data;

    switch (searchBy) {
      case "All":
        return InventoryDetailsExcelToRenderOverallComponent(list, filename);

      case "Area":
        return InventoryDetailsExcelToRenderAreaComponent(list, filename);

      case "Branch":
        return InventoryDetailsExcelToRenderBranchComponent(list, filename);

      default:
        return "No Value";
    }
  };

  renderNames = (data) => {
    let { searchBy } = this.props.data;

    switch (searchBy) {
      case "All":
        return data.clusterName;

      case "Area":
        return data.areaName;

      case "Branch":
        return data.branchName;

      default:
        return "No Value";
    }
  };

  renderName = () => {
    let { searchBy } = this.props.data;

    switch (searchBy) {
      case "All":
      case "Cluster":
        return "Cluster";

      case "Area":
        return "Area";

      case "Branch":
        return "Branch Name";

      default:
        return "No Value";
    }
  };

  renderCode = (data) => {
    let { searchBy } = this.props.data;
    switch (searchBy) {
      case "All":
        return data.clusterCode;

      case "Area":
        return data.areaCode;

      case "Branch":
        return data.branchCode;

      default:
        return "No Value";
    }
  };

  calculateOdPcs = (list) => {
    var totalActivePcs = list.reduce(
      (total, summary) => total + summary.totalPiecesDetails.active,
      0
    );

    var totalOverDuePieces = list.reduce(
      (total, summary) => total + summary.totalPiecesDetails.expired,
      0
    );

    var sum = totalActivePcs + totalOverDuePieces;

    var total = (totalOverDuePieces / sum) * 100;

    return total;
  };

  calculateOdAmt = (list) => {
    var totalActiveAmt = list.reduce(
      (total, summary) => total + summary.totalPrincipalDetails.active,
      0
    );

    var totalOverDuePrincipal = list.reduce(
      (total, summary) => total + summary.totalPrincipalDetails.expired,
      0
    );

    var sum = totalActiveAmt + totalOverDuePrincipal;

    var total = (totalOverDuePrincipal / sum) * 100;

    return total;
  };

  renderTotalRow = () => {
    return (
      <tr className="text-success strong">
        <td colSpan={this.props.data.searchBy === "Branch" ? "2" : "1"}>
          TOTAL
        </td>
        {/* <td>
          <span>
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) => total + summary.branchCount,
                0
              )
            )}
          </span>
        </td> */}

        <td>
          <span className="strong">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) => total + summary.totalPiecesDetails.active,
                0
              )
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) =>
                  total + summary.totalPrincipalDetails.active,
                0
              ),
              2
            )}
          </span>
        </td>

        <td>
          <span className="strong">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) => total + summary.totalPiecesDetails.expired,
                0
              )
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) =>
                  total + summary.totalPrincipalDetails.expired,
                0
              ),
              2
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(this.calculateOdPcs(this.props.data.list), 2)} %
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(this.calculateOdAmt(this.props.data.list), 2)} %
          </span>
        </td>

        <td>
          <span className="strong">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) => total + summary.totalPieces,
                0
              )
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) => total + summary.totalPrincipal,
                0
              ),
              2
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(
              this.getTotalPrincipal() / this.getTotalPieces(),
              2
            )}
          </span>
        </td>
      </tr>
    );
  };

  getTotalPrincipal = () => {
    return this.props.data.list.reduce(
      (total, summary) => total + summary.totalPrincipal,
      0
    );
  };

  getTotalPieces = () => {
    return this.props.data.list.reduce(
      (total, summary) => total + summary.totalPieces,
      0
    );
  };

  renderTable = () => {
    let { searchBy } = this.props.data;

    if (!this.props.data.list.length > 0) {
      return <NoTableData />;
    } else {
      return (
        <div id={`${searchBy}-printTable`}>
          <table className="custom-table ">
            <thead>
              <tr>
                {this.props.data.searchBy == "Branch" && <th>Branch Code</th>}
                <th>{this.renderName()}</th>
                {/* <th># of Branches</th> */}
                <th>Active Pcs</th>
                <th>
                  <span className="float-right">Active Amt</span>
                </th>
                <th>Overdue Pcs</th>
                <th>
                  <span className="float-right">Overdue Amt</span>
                </th>
                <th>
                  <span className="float-right">Percentage of OD Pcs</span>
                </th>
                <th>
                  <span className="float-right">Percentage of OD Amt</span>
                </th>
                <th>Total Pcs</th>
                <th>
                  <span className="float-right">Total Amt</span>
                </th>
                <th>
                  <span className="float-right">Ave/Amt/Pcs</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {this.props.data.list.map((item, idx) => {
                if (item !== undefined) {
                  return (
                    <tr key={idx}>
                      {this.props.data.searchBy == "Branch" && (
                        <td>{item.branchCode}</td>
                      )}
                      <td>
                        <div>
                          <div className="mr-1 d-inline">
                            {this.renderNames(item)}
                          </div>
                          {this.props.data.searchBy !== "Branch" && (
                            <Badge pill size="sm" variant="dark">
                              {this.renderCode(item)}
                            </Badge>
                          )}
                        </div>
                      </td>
                      {/* <td>{numberWithCommas(item.branchCount)}</td> */}
                      <td>
                        {numberWithCommas(item.totalPiecesDetails.active)}
                      </td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(
                            item.totalPrincipalDetails.active,
                            2
                          )}
                        </span>
                      </td>
                      <td>
                        {numberWithCommas(item.totalPiecesDetails.expired)}
                      </td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(
                            item.totalPrincipalDetails.expired,
                            2
                          )}
                        </span>
                      </td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(
                            item.totalPiecesDetails.expiredPercentage,
                            2
                          )}{" "}
                          %
                        </span>
                      </td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(
                            item.totalPrincipalDetails.expiredPercentage,
                            2
                          )}{" "}
                          %
                        </span>
                      </td>
                      <td>{numberWithCommas(item.totalPieces)}</td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(item.totalPrincipal, 2)}
                        </span>
                      </td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(item.averagePrincipalPerPiece, 2)}
                        </span>
                      </td>
                    </tr>
                  );
                } else {
                  return <></>;
                }
              })}
              {this.renderTotalRow()}
            </tbody>
          </table>
        </div>
      );
    }
  };

  onHandlePrint() {
    let { searchBy, filename } = this.props.data;

    var prtContent = document.querySelector(`.active #${searchBy}-printTable`);
    var WinPrint = window.open(
      "",
      "",
      "left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0"
    );
    WinPrint.document.write(
      `<html><head><title>${filename}</title>
       <link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" >
       <style type="text/css" media="print">
        @page { size: landscape; }
      </style>
      </head><body>`
    );

    WinPrint.document.write(prtContent.innerHTML);
    WinPrint.document.write(
      '<script type="text/javascript">window.print();window.close();</script>'
    );

    WinPrint.document.write("</body></html>");
    WinPrint.document.close();
  }

  renderOption = () => {
    return (
      <ButtonToolbar className="mr-3 float-left">
        <DropdownButton
          size="md"
          className="m-1"
          variant="primary"
          title={<FontAwesomeIcon icon={faPrint} />}
        >
          <Dropdown.Item
            onClick={() => {
              this.onHandlePrint();
            }}
          >
            Pdf
          </Dropdown.Item>

          {/* <PDFDownloadLink
            className="dropdown-item"
            document={this.renderPrintablePdfComponent(this.props.data.list)}
          >
            {({ blob, url, loading, error }) =>
              loading ? <Spinner size="sm" animation="border" /> : "PDF"
            }
          </PDFDownloadLink> */}
          {this.renderPrintableExcelComponent(this.props.data.list)}

          {/* <Dropdown.Item>Excel</Dropdown.Item> */}
        </DropdownButton>
      </ButtonToolbar>
    );
  };

  render() {
    return (
      <div className="p-3">
        {this.renderOption()}
        {this.state.isLoading ? <TableLoader /> : this.renderTable()}
      </div>
    );
  }
}

export default InventoryDetailsViewer;
